import React from "react";
import "./styles.css";
import "./mobile.css";
import { TableItemContainer } from "components/shared";

/**
 * @function NoFilesToDisplayTableRow
 * @param {STRING} colSpan - Sets the colspan number to the table row element of this component.  
 * @exported true
 * @returns {React.Component} 
 * @description This is the shared table row component that shows that there are no files to display in both tables in the PassThruACHPage.
 * @example
 * <TableBody>
 *   <NoFilesToDisplayTableRow colSpan="4" />
 * </TableBody>
 */
export default function NoFilesToDisplayTableRow(props){
  const colSpan = props.colSpan ?? "";
  return (
    <TableItemContainer>
      <td className="text-center no-files-to-display-table-row" colSpan={ colSpan }>
        <span>There are no files to display.</span>
      </td>
    </TableItemContainer>
  );
}
